import { makeStyles, shorthands, Spinner, Text, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100vw",
    backgroundColor: tokens.colorNeutralBackground3,
    ...shorthands.gap("16px"),
  },
  text: {
    marginTop: "16px",
    color: tokens.colorNeutralForeground1,
  },
});

type LoadingScreenProps = {
  message?: string;
};

export const LoadingScreen: React.FC<LoadingScreenProps> = (props: LoadingScreenProps) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Spinner size="large" />
      <Text className={styles.text} size={400}>
        {props.message}
      </Text>
    </div>
  );
};
